export let PaymentProcessorTypeEnumDTO = /*#__PURE__*/function (PaymentProcessorTypeEnumDTO) {
  PaymentProcessorTypeEnumDTO["Stripe"] = "stripe";
  PaymentProcessorTypeEnumDTO["Column"] = "column";
  return PaymentProcessorTypeEnumDTO;
}({});
export let PaymentStatusTypeEnumDTO = /*#__PURE__*/function (PaymentStatusTypeEnumDTO) {
  PaymentStatusTypeEnumDTO["Issued"] = "issued";
  PaymentStatusTypeEnumDTO["Canceled"] = "canceled";
  PaymentStatusTypeEnumDTO["Processed"] = "processed";
  PaymentStatusTypeEnumDTO["Succeeded"] = "succeeded";
  PaymentStatusTypeEnumDTO["Failed"] = "failed";
  PaymentStatusTypeEnumDTO["Refunded"] = "refunded";
  return PaymentStatusTypeEnumDTO;
}({});
export let DisputeStatusTypeEnumDTO = /*#__PURE__*/function (DisputeStatusTypeEnumDTO) {
  DisputeStatusTypeEnumDTO["Processing"] = "disputed_payment_processing";
  DisputeStatusTypeEnumDTO["Success"] = "disputed_payment_success";
  return DisputeStatusTypeEnumDTO;
}({});
export let FeeTransferStatusTypeEnumDTO = /*#__PURE__*/function (FeeTransferStatusTypeEnumDTO) {
  FeeTransferStatusTypeEnumDTO["Requested"] = "requested";
  FeeTransferStatusTypeEnumDTO["Completed"] = "completed";
  FeeTransferStatusTypeEnumDTO["Failed"] = "failed";
  return FeeTransferStatusTypeEnumDTO;
}({});
export let RefundStatusTypeEnumDTO = /*#__PURE__*/function (RefundStatusTypeEnumDTO) {
  RefundStatusTypeEnumDTO["Requested"] = "refundRequested";
  RefundStatusTypeEnumDTO["Pending"] = "refundPending";
  RefundStatusTypeEnumDTO["Initiated"] = "refundInitiated";
  RefundStatusTypeEnumDTO["Refunded"] = "refunded";
  RefundStatusTypeEnumDTO["Failed"] = "refundFailed";
  RefundStatusTypeEnumDTO["Cancelled"] = "refundCancelled";
  return RefundStatusTypeEnumDTO;
}({});
export let PaymentMethodEnumDTO = /*#__PURE__*/function (PaymentMethodEnumDTO) {
  PaymentMethodEnumDTO["Ach"] = "ach";
  PaymentMethodEnumDTO["CreditCard"] = "creditCard";
  return PaymentMethodEnumDTO;
}({});
export let FeesByEnumDTO = /*#__PURE__*/function (FeesByEnumDTO) {
  FeesByEnumDTO["Vendor"] = "vendor";
  FeesByEnumDTO["Customer"] = "customer";
  return FeesByEnumDTO;
}({});